export const assetUrl = (value) => {
  if (!value) return '';
  if (
    value.startsWith('http://') ||
    value.startsWith('https://') ||
    value.startsWith('data:') ||
    value.startsWith('blob:')
  ) {
    return value;
  }

  const base = process.env.REACT_APP_API_BASE_URL || 'https://www.millenniumrealtysf.com/api';
  return `${base.replace(/\/api$/, '')}${value}`;
};

const listingDetailBasePaths = {
  rent: '/rent',
  property: '/property-listing',
};

export const listingDetailPath = (listingType, slug) => {
  const basePath = listingDetailBasePaths[listingType];

  if (!basePath) {
    throw new Error(`Unsupported listing type: ${listingType}`);
  }

  return `${basePath}/${encodeURIComponent(slug)}`;
};
